<template>
  <div class="ding">
    <div class="container" style="width: 1280px;">
      <div class="one">
        <div class="da" :class="{openclass:open}">
          <div class="xinxi" style="margin-bottom: 0;" v-for="(item,index) in selectlist"><span>{{item.majorName}} </span>
          </div>
          <div style="font-size: 16px;" v-if="selectlist.length==0">您可以自选喜欢专业，不选择默认显示全部</div>
        </div>
        <div class="showAll" @click="openyixuan">已选专业 &nbsp;(&nbsp;{{selectlist.length}}&nbsp;)
          <div class="xia"></div>
        </div>
        <div class="btnconfirm" v-if="flag" @click="confirm">开始填报</div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    props: ["selectlist", "flag"],
    components: {

    },
    data() {
      return {
        open: false
      };
    },
    computed: {},
    methods: {
      del(index) {
        this.$emit("del", index);
      },
      confirm() {
        this.$emit("confirm");
      },
      openyixuan() {
        this.$emit("openyixuan");
      },
      clear() {
        this.$emit("clear");
      },
      update() {
        this.$router.push('/zhiyuanList_zyselect')

      }
    },
    mounted() {},
  };
</script>
<style scoped>
  .ding {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .btn {
    width: 90px;
    height: 30px;
    font-size: 16px;
    line-height: 15px;
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 10px;
  }

  .btnconfirm {
    /* background-color: #e63233;
    color: #FFFFFF; */
    width: 200px;
    height: 100%;
    background-color: #f66464;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .showAll {
    width: 200px;
    text-align: right;
    padding-right: 10px;
    font-size: 18px;
    color: #29A7E1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .showAll .xia {
    width: 12px;
    height: 15px;
    margin-left: 10px;
    background-repeat: no-repeat;
    transform: rotate(180deg);
    background-size: 100% 100%;
    background-image: url(../views/images/icon_xia.png);
  }

  .btnclear {
    color: #666;
    border: 1px solid #666;
  }

  .da {
    display: flex;
    justify-content: row;
    flex-wrap: nowrap;
    align-items: center;
    flex-shrink: 0;
    width: 850px;
    height: 100%;
    overflow: hidden;
    margin-left: 20px;
  }

  .openclass {
    height: auto;
    overflow: inherit;
  }

  .update {}

  .update a {
    color: #29A7E1;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
  }

  .one {
    justify-content: flex-end;
    align-items: flex-start;
    width: 1280px;
    margin: 0 auto;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    display: flex;
    align-items: center;
  }

  .one span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
  }

  /* .one span,.xinxi img {
  margin-right: 8px;
} */
  /* 设置个别宽度不是以下不是此范围的样式 */
  .container {
    width: 1280px;
  }

  .xinxi1 {
    margin-right: 8px;
    display: flex;
    align-items: center;
    width: 105px;

  }

  .xinxi1 a {
    padding-left: 9px;
    text-decoration: none;
    color: #29A7E1;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;

  }

  .xinxi img {
    width: 8px;
    height: 8px;
    margin-top: -3px;
  }

  .xinxi {
    padding: 0 5px 0 5px;
    width: auto;
    flex-shrink: 0;
    height: 25px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29A7E1;
    opacity: 1;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    line-height: 25px;

  }

  .xinxi span {
    text-align: center;
    font-size: 14px;
    text-decoration: none;
    color: #29A7E1;
    font-family: PingFang SC;
    font-weight: 500;

  }
</style>



// WEBPACK FOOTER //
// src/components/vMassage2.vue